<template>
  <v-autocomplete
    v-model="selectedConsultant"
    attach="#imaginary-attachment"
    :error-messages="error"
    :items="consultants"
    :label="$t('Consultants')"
    :multiple="multiple"
    :class="inputCssClass"
    chips
    item-text="user[name]"
    item-value="id"
    box
  >
    <template slot="selection" slot-scope="data">
      <v-chip :selected="data.selected" close class="chip--select-multi" @input="remove(data.item)">
        <v-avatar>
          <v-icon>mdi-account</v-icon>
        </v-avatar>
        {{ data.item.name }}
      </v-chip>
    </template>
    <template slot="item" slot-scope="data">
      <template>
        <v-list-tile-avatar>
          <v-icon>mdi-account</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
          <v-list-tile-sub-title>
            <template v-for="cat in data.item.categories">
              {{ cat }}
            </template>
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import ProfileAPI from '@/services/api/profile.js';

export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  props: {
    value: {
      type: [Object, Array, Number, String],
    },
    inputCssClass: {
      type: [Object, String],
    },
    multiple: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    error: {
      type: String,
    },
  },
  data() {
    return {
      consultants: [],
      selectedConsultant: this.value,
    };
  },
  mounted() {
    ProfileAPI.myConsultants().then(res => {
      this.consultants = [];
      res.data.data.forEach(element => {
        // element.user.categories = element.categories;
        this.consultants.push(element);
      });
    });
  },
  watch: {
    selectedConsultant: {
      handler: function(val, oldVal) {
        this.$emit('input', this.selectedConsultant);
      },
      deep: true,
    },
  },
};
</script>

<style></style>
